var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1024,
    height: 237,
    viewBox: "0 0 1024 237",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 236.596H1024C1017.68 232.675 1011.62 228.755 1005.96 224.686C978.092 204.656 977.059 180.917 975.923 154.811C974.272 116.867 972.404 73.9206 887.619 30.0898C807.727 -11.2121 731.176 -0.659873 644.575 11.2778C576.04 20.7251 501.21 31.0402 413.448 17.2084C249.631 -8.64767 180.681 81.1735 126.169 152.187C114.575 167.29 103.634 181.543 92.5723 193.651C65.9275 222.855 34.0699 229.553 0 236.596Z",
    fill: "#F5F5F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.0c67aa561f4b598da9456475f6489bee.svg";
export { ForwardRef as ReactComponent };